import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// style components
import Table from '../../../components/Table/Table';
import Status from '../Status/Status';
import getStatus from '../../libs/getStatus.order';
import ExtendedOrderRow from '../ExtendedOrderRow/ExtendedOrderRow';
import { ExpandIcon, ExpandButton, DepartmentName } from './OrdersTable.styled';

// data
import columns from './data/columns';

// libs
import toPrettyDate from '../../../lib/toPrettyDate';
import getHighestDeliveryDate from '../../libs/getHighestDeliveryDate.order';
import formatCurrency from '../../../lib/formatCurrency';

const OrdersTable = ({sort, rows, onSort, onStatusChange}) => {
  const { t } = useTranslation();
  const [expandedRows, setExpandedRows] = useState({});

  const handleRowClick = (id, isOpen) => {
    setExpandedRows(prev => ({ ...prev, [id]: isOpen }));
  };

  return (
    <Table
      columns={columns(t)}
      size="medium"
      headerSize="large"
      noMargin={false}
      labelSpace={false}
      onSort={onSort}
      sort={sort}
      theme="white"
    >
      {(TableRow) =>
        rows.map((row) => (
          <TableRow
            key={row._id}
            id={row._id}
            noMargin={false}
            rowClick={handleRowClick}
            dropdown={
              <ExtendedOrderRow
                orderId={row._id}
                status={row.status}
                nestedRows={row.orderRows}
                onStatusChange={onStatusChange}
              />
            }
          >
            {(TableCol) => [
              <TableCol key="expand" span={1} align="center">
                <ExpandButton>
                  <ExpandIcon 
                    className="mdi mdi-chevron-down" 
                    isOpen={expandedRows[row._id]}
                  />
                </ExpandButton>
              </TableCol>,
              <TableCol key="orderNo" span={2} align="center">
                {row.orderNumber}
              </TableCol>,
              <TableCol key="ediOrderNo" span={2} align="center">
                {row.orderRows[0]?.documentId}
              </TableCol>,
              <TableCol key="createdAt" span={2} align="center">
                {toPrettyDate(row.createdAt)}
              </TableCol>,
              <TableCol key="estimatedDelivery" span={2} align="center">
                {row.orderRows && row.orderRows.length
                  ? getHighestDeliveryDate(row.orderRows)
                  : '-'}
              </TableCol>,
              <TableCol key="department" span={2} align="center">
                <DepartmentName>
                  {row.department?.name || '-'}
                </DepartmentName>
              </TableCol>,
              <TableCol key="status" align="center" span={2}>
                <Status props={getStatus(row.status, t)} />
              </TableCol>,
              <TableCol key="price" align="center" span={2}>
                {formatCurrency(row.price)}
              </TableCol>,
            ]}
          </TableRow>
        ))
      }
    </Table>
  );
};

OrdersTable.propTypes = {
  rows: PropTypes.array,
  sort: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.string,
  }),
  onSort: PropTypes.func,
  onStatusChange: PropTypes.func,
};

export default OrdersTable;
